import React from 'react'
import schema from '../jsonschemas/infrastructure/infrastructure_1/infrastructure_one.json'
import uiSchema from '../jsonschemas/infrastructure/infrastructure_1/web_ui_schema.json'
import { FormPreview } from './FormPreview'

export function TestSchema1() {
  return <FormPreview schema={schema} uiSchema={uiSchema} />
}
